<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="TclcScrutiny">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class=" d-flex align-items-center">
                                            <img alt="Logo" src="../../assets/img/approve.png" class="mh-45px pb-2">
                                            <p class="mb-1">
                                                <span class="main-content-label"><b>Student Certificate Request
                                                        Scrutiny</b></span><br>
                                                <span class="text-muted card-sub-title mb-0">List Of Student Certificate
                                                    Request Scrutiny</span>
                                            </p>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="row clearfix mt-2">

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Request Type
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="CertType" [displayMember]="'CgDesc'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [array]="CertList"
                                                                (filteredReturn)="filteredCertList =$event">
                                                            </mat-select-filter>
                                                            <mat-option [value]="'All'" (click)="ShowTable()">
                                                                All
                                                            </mat-option>
                                                            <mat-option *ngFor="let item of filteredCertList"
                                                                [value]="item.CdCode" (click)="ShowTable()">
                                                                {{item.CdCode}} - {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                   <mat-label>Payment / Application Status</mat-label>
                                                        <mat-select formControlName="FeeAppStatus"
                                                            (selectionChange)="onFeeAppStatusChange($event.value)">
                                                        <mat-option value="">
                                                            All
                                                        </mat-option>
                                                        <mat-option value="Fees Paid">
                                                            Fees Paid
                                                        </mat-option>
                                                        <mat-option value="APPAP">
                                                            Application Approved
                                                        </mat-option>
                                                        <mat-option value="REC">
                                                            Rectify
                                                        </mat-option>
                                                        </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-3"></div>
                                        <div class="col-md-3" [formGroup]="SearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>


                                        <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                                            <div>
                                                <p class="mb-1">
                                                    <span class="main-content-label"><b>Student Request</b></span><br>
                                                </p>
                                            </div>
                                            <table class="table table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr class="text-left">
                                                        <th class="f600 text-center">
                                                            View
                                                        </th>
                                                        <th class="f600">
                                                            RgNo
                                                        </th>
                                                        <th class="f600">
                                                            Student Name
                                                        </th>
                                                        <th class="f600">
                                                            Course Name
                                                        </th>
                                                        <!-- <th class="f600">
                                                                        College
                                                                    </th> -->
                                                        <th class="f600">
                                                            Request Type
                                                        </th>
                                                        <th class="f600">
                                                            Request Status
                                                        </th>
                                                        <th class="f600">
                                                            Status By
                                                        </th>
                                                        <th class="f600">
                                                           Payment Date
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr *ngFor="let tclc of TclcData; let i = index"
                                                        [class.disabled-row]="(tclc.CertType == 'ADMC' && tclc.RgStatus == 'L') || (tclc.CertType == 'TS' && tclc.CertStatus == 'Submitted') ">

                                                        <td class="text-center">
                                                            <i class="fa fa-eye eye" (click)="details(tclc)"></i>
                                                        </td>
                                                        <td>
                                                            {{tclc.RgNo === null ? tclc.StuPRN : tclc.RgNo}}
                                                        </td>
                                                        <td class="labelStyle" matTooltip="Click To View">
                                                            <a>{{tclc.StuFirstNameEng === null ? tclc.StuName :
                                                                tclc.StuFirstNameEng + ' ' + tclc.StuMidNameEng + ' ' +
                                                                tclc.StuLastNameEng}}</a>
                                                        </td>
                                                        <td>
                                                            {{tclc.CoName}}
                                                        </td>
                                                        <!-- <td>
                                                                            {{tclc.CgName}}
                                                                        </td> -->
                                                        <td>
                                                            <!-- {{tclc.CertType == 'TC' ? 'Transfer Certificate' : (tclc.CertType == 'LC' ? 'Leaving Certificate' : (tclc.CertType == 'MC' ? 'Migration Certificate' : (tclc.CertType == 'ADMC' ? 'Admission Cancellation' : (tclc.CertType == 'TS' ? 'Transcript Certificate' : ''))))}} -->
                                                            {{getRequest(tclc)}}
                                                        </td>
                                                        <td>
                                                            {{getStatus(tclc)}}
                                                        </td>
                                                        <td>
                                                            {{tclc.StatusBy}}
                                                        </td>
                                                         <td>
                                                            {{tclc.CreatedAt}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                                [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageIndex"
                                                (page)="onPageChange($event)">
                                            </mat-paginator>
                                        </div>

                                        <div *ngIf="Incoming" class="table-responsive table-container tab mt-1">
                                            <div>
                                                <p class="mb-1">
                                                    <span class="main-content-label"><b>Incoming Student
                                                            Request</b></span><br>
                                                </p>
                                            </div>
                                            <table class="table table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr class="text-left">
                                                        <th class="f600 text-center">
                                                            View
                                                        </th>
                                                        <th class="f600">
                                                            RgNo
                                                        </th>
                                                        <th class="f600">
                                                            Student Name
                                                        </th>
                                                        <th class="f600">
                                                            Course Name
                                                        </th>
                                                        <th class="f600">
                                                            College
                                                        </th>
                                                        <th class="f600">
                                                            Request Type
                                                        </th>
                                                        <th class="f600">
                                                            Request Status
                                                        </th>
                                                        <th class="f600">
                                                            Status By
                                                        </th>

                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr *ngFor="let tclc of TclcIncoming; let i = index">

                                                        <td class="text-center">
                                                            <i class="fa fa-eye eye" (click)="details(tclc)"></i>
                                                        </td>
                                                        <td>
                                                            {{tclc.RgNo}}
                                                        </td>
                                                        <td class="labelStyle" matTooltip="Click To View">
                                                            <a>{{tclc.StuFirstNameEng}} {{ tclc.StuMidNameEng}} {{
                                                                tclc.StuLastNameEng}}</a>
                                                        </td>
                                                        <td>
                                                            {{tclc.CoName}}
                                                        </td>
                                                        <td>
                                                            {{tclc.CgName}}
                                                        </td>
                                                        <td>
                                                            {{tclc.CertType == 'TC' ? 'Transfer Certificate' :
                                                            (tclc.CertType == 'LC' ? 'Leaving Certificate' :
                                                            (tclc.CertType == 'MC' ? 'Migration Certificate' :
                                                            (tclc.CertType == 'ADMC' ? 'Admission Cancellation' :
                                                            '')))}}
                                                        </td>
                                                        <td>
                                                            {{getStatus(tclc)}}
                                                        </td>
                                                        <td>
                                                            {{tclc.StatusBy}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>